import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { Header } from '../components/Header';
import { TabsComponent } from '../components/Tabs';
import { ZmSyncBanner } from '../components/ZmSyncBanner';
import { colors } from '../theme/colors';
import { useAuth } from '../contexts/AuthContext';
import type { AuthUser } from '../utils/auth';
import type { QueryClient } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';

interface RouterContext {
  auth: {
    user: AuthUser | null;
    isAuthenticated: boolean;
  };
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  notFoundComponent: NotFoundComponent,
});

function RootComponent() {
  const { isAuthenticated, user } = useAuth();
  const isContactSupport = window.location.pathname === '/contact-support';

  if (!isAuthenticated || isContactSupport) {
    return <Outlet />;
  }

  return (
    <div className="flex h-screen flex-col bg-neutral-50 font-sans">
      <Header />
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden px-4 pt-14 max-w-[1400px] mx-auto w-full max-h-screen">
        <ZmSyncBanner />
        <TabsComponent>
          <Outlet />
        </TabsComponent>
      </div>
    </div>
  );
}

function NotFoundComponent() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '2rem',
        backgroundColor: colors.neutral.grey[50],
      }}
    >
      <h1
        style={{
          fontSize: '3rem',
          fontWeight: 'bold',
          color: colors.neutral.grey[900],
          marginBottom: '1rem',
        }}
      >
        404
      </h1>
      <p
        style={{
          fontSize: '1.25rem',
          color: colors.neutral.grey[600],
          marginBottom: '2rem',
          textAlign: 'center',
        }}
      >
        Page not found
      </p>
      <Link
        to="/time-entry"
        style={{
          padding: '0.75rem 1.5rem',
          backgroundColor: colors.accent.blue,
          color: 'white',
          textDecoration: 'none',
          borderRadius: '6px',
          fontWeight: '500',
          transition: 'background-color 0.2s',
        }}
      >
        Go to Time Entry
      </Link>
    </div>
  );
}

